import React from "react";
import cadeauImg from "../../img/carte_cadeau.jpg";

function CarteCadeau() {
  return (
    <div className="w-full bg-white">
      <div className="mx-12 px-4 md:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-lg bg-orange-50 flex items-right justify-center">
            <img
              src={cadeauImg}
              alt="Carte cadeau Mood"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex flex-col gap-4">
            <h1 className="text-2xl md:text-2xl font-bold text-slate-900">
              <span>Offrez une bulle de déconnexion </span><br></br><span>et de créativité à ceux que vous aimez !</span>
            </h1>
            <p className="text-slate-700 leading-relaxed">
            Commandez prochainement votre carte cadeau mood directement en ligne.
            </p>
            <p className="text-slate-700 leading-relaxed">
            En attendant, les cartes cadeaux sont disponibles au café-atelier.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarteCadeau;
